import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { surveyJSApiRef } from './components/apis/SurveyJSApi';
import { SurveyJSApiClient } from './components/apis/SurveyJSClient';

export const surveyjsFrontendPlugin = createPlugin({
  id: 'surveyjs-frontend',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: surveyJSApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new SurveyJSApiClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const SurveyjsFrontendPage = surveyjsFrontendPlugin.provide(
  createRoutableExtension({
    name: 'SurveyjsFrontendPage',
    component: () =>
      import('./components/MainComponent').then(m => m.MainComponent),
    mountPoint: rootRouteRef,
  }),
);
